'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { isChunkLoadError, reloadOnceForChunkError } from '../lib/chunkReload'

// Error boundary for every page (renders inside the root layout, so the site
// header stays). Replaces Next's plain "This page couldn't load" fallback.
export default function Error({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  const staleBuild = isChunkLoadError(error)
  const [reloading, setReloading] = useState(false)

  useEffect(() => {
    console.error(error)
    if (reloadOnceForChunkError(error)) setReloading(true)
  }, [error])

  return (
    <main className="section section-white">
      <div className="container" style={{ paddingTop: '4rem', paddingBottom: '4rem', maxWidth: '46rem' }}>
        {reloading ? (
          <>
            <h1>Loading the latest version</h1>
            <p>The site was updated while this tab was open. One moment.</p>
          </>
        ) : (
          <>
            <h1>This page didn&rsquo;t finish loading</h1>
            <p>
              {staleBuild
                ? 'The site was updated while this tab was open. Reload the page to get the latest version.'
                : 'Something on this page failed to load. Try again, or head back to the homepage.'}
            </p>
            <div className="team-edit-actions" style={{ marginTop: '1.5rem' }}>
              <button
                type="button"
                className="primary-pill large"
                onClick={() => (staleBuild ? window.location.reload() : retry())}
              >
                {staleBuild ? 'Reload page' : 'Try again'}
              </button>
              <Link href="/" className="secondary-pill">Back to homepage</Link>
            </div>
          </>
        )}
      </div>
    </main>
  )
}
